import React from 'react';
import { connect } from "react-redux";
import APP from 'app';
import Constants from 'constants';
import { saveErrors } from 'actions/refreshTokenActions';

const { Utils } = APP,
    { isMobile, translateText } = Utils;


class ErrorBoundary extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            error: null,
            errorInfo: null
        };
    }

    componentDidCatch(error, errorInfo) {
        // Catch errors in any components below and re-render with error message
        this.setState({
            error: error,
            errorInfo: errorInfo
        });
        const { userId = '' } = this.props.userInfo;
        this.props.saveErrors({
            userId,
            error: error,
            errorInfo: errorInfo,
            label: "Hotel",
            Url: window.location.href,
            deviceType: isMobile() ? 'Mobile' : 'Desktop'
        })

    }

    static getDerivedStateFromProps(nextProps) {
        const { errorHandler = {} } = nextProps;
        const { errors = [] } = errorHandler;
        if (!_.isEmpty(errors)) {
            APP.Utils.showErrorMsg(errors);
            APP.MessageBus.trigger(Constants.actions.ERROR_HANDLER.HIDE_ERROR_MESSAGE, {
                success: false
            });
            return null;
        }
        return null;
    }



    render() {
        const imageUrl = Constants.module.STATIC_BASE_URL + "/img/error404.jpg";
        if (this.state.error) {
            return <div className="error__page__container">
                <center>
                    <div className="row error__page-height">
                        <img src={imageUrl} className="img-responsive" />
                    </div>
                    <div className="error__page__contnetbox">
                        <p className="error_page_paragraph">{translateText('404_errorMsg', 'errorPage')}</p>
                        <a href="/" className="btn btn-warning error_button_homepage">{translateText('goToHomePage', 'errorPage')}</a>
                        <p className="error_page_paragraph">{translateText('orExploreBy', 'errorPage')}</p>
                        <a href="/flight" className="error_button_link">{translateText('flightBooking', 'errorPage')}</a>
                        <a href="#" className="error_button_link">{translateText('hotelBooking', 'errorPage')}</a>
                    </div>
                </center>
            </div>
        }
        return this.props.children;
    }
}




const mapStateToProps = state => {
    const { userinfos = {}, errorHandler = {} } = state;
    const { userInfo = {} } = userinfos;
    return {
        userInfo,
        errorHandler
    }
};

const mapDispatchToProps = dispatch => ({
    saveErrors(payload) {
        dispatch(saveErrors(payload))
    }
})

export default connect(mapStateToProps, mapDispatchToProps)(ErrorBoundary);